import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    width: 40,
    height: 40,
    fontSize: 12,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: theme.palette.background.dark,
    backgroundColor: theme.palette.background.light,
  },
  large: {
    width: 80,
    height: 60,
    fontSize: 15,
    borderRadius: 10,
  },
})

const DashboardIcon = ({
  classes, className, data, large 
}) => (
  <div
    style={{
      backgroundImage: data && `url('${data}')`,
    }}
    className={classNames(classes.root, large && classes.large, className)}>
    {!data && <span>logo</span>}
  </div>
)

DashboardIcon.defaultProps = {
  large: false,
}

DashboardIcon.propTypes = {
  large: PropTypes.bool,
  data: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(DashboardIcon)



// WEBPACK FOOTER //
// ./src/components/atoms/DashboardIcon.js